// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Sort: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11">
            <path
                fill="#393939"
                d="M3.22161688,1.47031236 C3.51458563,1.17734361 3.99036695,1.17734361 4.2833357,1.47031236 L7.28333606,4.47031236 C7.49896134,4.68593693 7.56224216,5.00703096 7.44505466,5.28828096 C7.32786716,5.56953096 7.05599202,5.75234354 6.75130452,5.75234354 L0.75130452,5.75234354 C0.448960913,5.75234354 0.174742235,5.56953096 0.0575547349,5.28828096 C-0.0596327651,5.00703096 0.00599230644,4.68593693 0.219273699,4.47031236 L3.2192737,1.47031236 L3.22161688,1.47031236 Z M3.22161723,11.5320308 L0.221617235,8.53203082 C0.00599230644,8.31640553 -0.057288872,7.99531221 0.059898628,7.71406221 C0.177086128,7.43281221 0.448961271,7.25 0.753648771,7.25 L6.75130524,7.25 C7.05364884,7.25 7.32786788,7.43281221 7.44505538,7.71406221 C7.56224288,7.99531221 7.49661816,8.31640625 7.28333677,8.53203082 L4.28333677,11.5320308 C3.99036802,11.8249996 3.5145867,11.8249996 3.22161795,11.5320308 L3.22161723,11.5320308 Z"
                transform="translate(-.001 -1)"
            />
        </svg>
    );
};

export default React.memo(Sort)
